// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const RedoIcon = props => <Icon {...props} dangerouslySetIcon={'<svg viewBox="0 0 24 24" fill="currenColor" xmlns="http://www.w3.org/2000/svg"><path d="M18.293 6.707C16.474 4.89 14.226 4 12 4c-3.557 0-8 3.156-8 8 0 4.448 3.552 8 8 8 3.479 0 6.15-2.178 7.134-5.3a1 1 0 111.907.6C19.816 19.195 16.415 22 12 22 6.448 22 2 17.552 2 12 2 5.844 7.557 2 12 2c2.774 0 5.526 1.111 7.707 3.293L22 7.586V4a1 1 0 112 0v6a.997.997 0 01-.997 1H17a1 1 0 110-2h3.586l-2.293-2.293z"/></svg>'} />;

RedoIcon.displayName = 'RedoIcon';

export default RedoIcon;
